import React, { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import {
  BriefcaseIcon,
  WrenchScrewdriverIcon,
  CpuChipIcon,
  TrophyIcon,
} from "@heroicons/react/24/outline";

import GaleriTraining from "./galeri/GaleriTraining";
import GaleriOperations from "./galeri/GaleriOperations";
import GaleriService from "./galeri/GaleriService";
import GaleriCertificate from "./galeri/GaleriCertificate";

const tabs = [
  { id: "training", label: "Training", icon: BriefcaseIcon, component: <GaleriTraining /> },
  { id: "operations", label: "Operations", icon: WrenchScrewdriverIcon, component: <GaleriOperations /> },
  { id: "service", label: "Service", icon: CpuChipIcon, component: <GaleriService /> },
  { id: "certificate", label: "Certificate", icon: TrophyIcon, component: <GaleriCertificate /> },
];

export default function DataGaleri() {
  const [activeTab, setActiveTab] = useState(tabs[0].id);

  // ✅ Saat halaman pertama kali dibuka, scroll ke atas
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "auto" });
  }, []);

  return (
    <div className="w-full h-full p-4 sm:p-6 bg-white/60 backdrop-blur-xl rounded-2xl shadow-lg border border-white/50 flex flex-col">
      {/* Header */}
      <div className="mb-6">
        <h2 className="text-xl sm:text-2xl font-bold text-gray-800">
          <span className="text-transparent bg-clip-text bg-gradient-to-r from-green-600 to-teal-500">
            Kelola Galeri
          </span>
        </h2>
        <p className="text-sm text-gray-600 mt-1">
          Atur dan kelola dokumentasi kegiatan perusahaan berdasarkan kategori.
        </p>
      </div>

      {/* Tab Navigation */}
      <div className="flex flex-col sm:flex-row w-full space-y-1 sm:space-y-0 sm:space-x-1 bg-green-900/5 p-1.5 rounded-xl mb-6">
        {tabs.map((tab) => {
          const Icon = tab.icon;
          return (
            <button
              key={tab.id}
              onClick={() => setActiveTab(tab.id)}
              className={`relative w-full flex items-center justify-start sm:justify-center gap-2 px-4 py-2.5 text-sm font-semibold transition
                ${activeTab === tab.id ? "text-green-800" : "text-gray-600 hover:text-green-700 hover:bg-white/40"}`}
            >
              {activeTab === tab.id && (
                <motion.span
                  layoutId="active-tab-galeri"
                  className="absolute inset-0 z-0 bg-white shadow-md rounded-lg"
                  transition={{ type: "spring", stiffness: 300, damping: 30 }}
                />
              )}
              <span className="relative z-10 flex items-center gap-2">
                <Icon className="w-5 h-5" />
                <span>{tab.label}</span>
              </span>
            </button>
          );
        })}
      </div>

      {/* Tab Content */}
      <div className="flex-1 mt-4">
        <AnimatePresence mode="wait">
          <motion.div
            key={activeTab}
            initial={{ opacity: 0, y: 15 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -15 }}
            transition={{ duration: 0.25 }}
          >
            {tabs.find((tab) => tab.id === activeTab)?.component}
          </motion.div>
        </AnimatePresence>
      </div>
    </div>
  );
}
